import { useEffect, useState } from "react";

const KEY = "pechespot_catches";
const EVT = "catches-changed";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
};

export const useCatches = () => {
  const [catches, setCatches] = useState(read);

  useEffect(() => {
    const sync = () => setCatches(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const add = (c) => write([{ ...c, id: crypto.randomUUID() }, ...read()]);
  const remove = (id) => write(read().filter((c) => c.id !== id));

  return { catches, add, remove };
};
